import { ChevronDown, Filter, Plus } from "lucide-react";

export default function SectionHeader({ eyebrow, title, description, action }) {
  return (
    <section className="section-heading" data-testid="section-heading">
      <div>
        <span className="eyebrow" data-testid="page-eyebrow">{eyebrow}</span>
        <h1 data-testid="page-title">{title}</h1>
        <p data-testid="page-description">{description}</p>
      </div>
      <div className="heading-actions">
        <button className="secondary-button" data-testid="date-range-button">
          Last 7 days <ChevronDown size={15} />
        </button>
        <button className="icon-button desktop-filter" data-testid="filter-button" aria-label="Filter results">
          <Filter size={16} />
        </button>
        <button className="primary-button" data-testid="page-primary-action">
          <Plus size={16} />{action}
        </button>
      </div>
    </section>
  );
}